import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const EditableList = ({
  uploadDoc,
  responseDoc,
  onResponseClick,
  onUploadClick,
}) => {
  return (
    <List
      sx={{
        width: "75%",
        maxWidth: 320,
        fontSize: "12px",
        border: "none",
      }}
    >
      {responseDoc.map((val, index) => {
        return (
          <>
            <ListItem
              sx={{
                backgroundColor: "#f2f9f6",
                border: "1px solid #aad2c0",
                borderRadius: "5px",
                marginBottom: "5px",
                marginRight: "10px",
              }}
              key={index}
              secondaryAction={
                <IconButton
                  sx={{
                    backgroundColor: "#f98585",
                    borderRadius: "100%",
                    color: "white",
                    width: "20px",
                    height: "20px",
                  }}
                  onClick={() => onResponseClick(val, index)}
                  aria-label="comment"
                >
                  <CloseIcon sx={{ fontSize: "12px" }} />
                </IconButton>
              }
            >
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "12px", overflow: "clip" }}>
                    {val.documentName?.split("_")[1]}
                  </Typography>
                }
              />
            </ListItem>
          </>
        );
      })}

      {uploadDoc?.map((list, index) => (
        <List>
          <>
            <ListItem
              sx={{
                backgroundColor: "#f2f9f6",
                border: "1px solid #aad2c0",
                borderRadius: "5px",
                marginBottom: "5px",
              }}
              key={index}
              secondaryAction={
                <IconButton
                  sx={{
                    backgroundColor: "#f98585",
                    borderRadius: "100%",
                    color: "white",
                    width: "20px",
                    height: "20px",
                  }}
                  onClick={() => onUploadClick(list, index)}
                  aria-label="comment"
                >
                  <CloseIcon sx={{ fontSize: "12px" }} />
                </IconButton>
              }
            >
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "12px", overflow: "clip" }}>
                    {list?.name}
                  </Typography>
                }
              />
            </ListItem>
          </>
        </List>
      ))}
    </List>
  );
};
